import React from 'react';
import { useTranslation } from 'react-i18next';
import PricingCard from './PricingCard';

const PricingSection: React.FC = () => {
  const { t } = useTranslation();
  const plans = t('landing.pricing.plans', { returnObjects: true }) as Array<{
    title: string;
    description: string;
    price: string;
    period: string;
    features: string[];
    button: string;
  }>;

  return (
    <section id="pricing" className="py-20">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl sm:text-5xl font-bold text-white mb-6">
            {t('landing.pricing.title').includes('Nos Tarifs') ? (
              <>
                Nos{' '}
                <span className="bg-gradient-to-r from-emerald-400 to-cyan-400 bg-clip-text text-transparent">
                  Tarifs
                </span>{' '}
                <span className="bg-gradient-to-r from-yellow-400 to-orange-400 bg-clip-text text-transparent">
                  Flexibles
                </span>
              </>
            ) : (
              <>
                Our{' '}
                <span className="bg-gradient-to-r from-emerald-400 to-cyan-400 bg-clip-text text-transparent">
                  Flexible
                </span>{' '}
                <span className="bg-gradient-to-r from-yellow-400 to-orange-400 bg-clip-text text-transparent">
                  Pricing
                </span>
              </>
            )}
          </h2>
          <p className="text-xl text-slate-300 max-w-4xl mx-auto leading-relaxed">
            {t('landing.pricing.subtitle')}
          </p>
        </div>
        
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 items-end">
          {plans.map((plan, index) => (
            <PricingCard
              key={index}
              title={plan.title}
              description={plan.description}
              price={plan.price}
              period={plan.period}
              features={plan.features}
              buttonText={plan.button}
              buttonVariant={index === 2 ? 'primary' : 'secondary'}
              popular={index === 2}
              delay={index * 100}
            />
          ))}
        </div>
      </div>
    </section>
  );
};

export default PricingSection;